module.exports = __webpack_public_path__ + "img/73.5.COD.b33027b3.png";